// extracted by mini-css-extract-plugin
export default {"editable":"editable-ac8dc43f"};